import styled from '@emotion/styled';

export const SadaWorkingHoursPicker = styled.div``;
